import React from "react";
import { Badge } from "@emisgroup/ui-badge";
import { BadgeVariant } from "../Types";

interface BadgeProps {
  /**
    * To show zero value
    */
  showZero?: boolean;
  /**
    * The badge value
    *
    * @type {string | number}
    */
  value: string | number;
  /**
    * The badge's color.
    */
  variant?: BadgeVariant;
  /**
   * Custom class name for badge component
   */
  className?: string;
}

/**
 * Responsible for rendering the badge component
 * @returns badge element
 */
export const UIBadge: React.FC<BadgeProps> = (props: BadgeProps) => {

  return (
    <Badge
      {...props}
    >
    </Badge>
  );
};
